module.exports = __webpack_public_path__ + "img/vestibulares-anteriores.be3a4cec.png";